import { useState, useEffect } from "react";
import { Alert, Divider, IconButton, List, TextField } from "@mui/material";
import { DoNotDisturb, Edit, Save } from "@mui/icons-material";
import localize from "../../../common/localize";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";

export default function AdditionalData({ event, setEvent }) {
  const [additionalFields, setAdditionalFields] = useState();
  const [editableField, setEditableField] = useState();
  const [previousValue, setPreviousValue] = useState("");
  const [saveRequested, setSaveRequested] = useState(false);

  const handleFieldChange = (field, newFieldValue) => {
    saveValue(field.guid, newFieldValue);
  };

  const extractAdditionalInfo = (jsonData) => {
    if (jsonData && jsonData.length > 0) {
      const data = JSON.parse(jsonData);

      if (
        event?.AdditionalFieldValue &&
        event?.AdditionalFieldValue.length > 0
      ) {
        event?.AdditionalFieldValue.forEach((field) => {
          const index = data.findIndex((x) => x.guid === field.guid);
          if (index >= 0) {
            data[index] = {
              ...data[index],
              value: field.value,
            };
          }
        });
      }

      return data;
    }

    return [];
  };

  const addForEdition = (guid, currentValue) => {
    setPreviousValue(currentValue ?? "");
    if (!isEditable(guid)) {
      setEditableField(guid);
    }
  };

  const removeFromEdition = (guid) => {
    setEditableField(null);
  };

  const cancelEdition = (guid) => {
    setSaveRequested(true);
    saveValue(guid, previousValue);
    setPreviousValue("");
    removeFromEdition(guid);
  };

  const isEditable = (guid) => editableField === guid;

  const saveValue = (guid, newValue) => {
    setSaveRequested(true);
    const index = additionalFields.findIndex((x) => x.guid === guid);
    if (index >= 0) {
      additionalFields[index] = {
        ...additionalFields[index],
        value: newValue,
      };
      setAdditionalFields([...additionalFields]);
    }
  };

  useEffect(() => {
    if (saveRequested) {
      setSaveRequested(false);
      setEvent({
        ...event,
        AdditionalFieldValue: [...additionalFields],
      });
    }
  }, [additionalFields]);

  useEffect(() => {
    if (event?.EventType?.AdditionalFields) {
      setAdditionalFields(
        extractAdditionalInfo(event?.EventType?.AdditionalFields)
      );
    }
  }, [event?.EventType]);

  return (
    <div className="w-full">
      {additionalFields && additionalFields.length > 0 ? (
        <List className="w-full flex flex-col gap-2">
          {additionalFields.map((field) => (
            <div key={field.guid} className="flex-col w-full">
              <div className="flex w-full justify-between items-center gap-2">
                <div style={{ maxWidth: "30%", minWidth: "30%", width: "30%" }}>
                  <label className="text-xs">{field.name}</label>
                </div>

                <TextField
                  InputLabelProps={getInputLabelProps()}
                  inputProps={{
                    ...getInputProps(),
                    onKeyUp: (event) => {
                      if (event.key === "Enter") {
                        setPreviousValue("");
                        removeFromEdition(field.guid);
                        event.preventDefault();
                      }
                    },
                  }}
                  disabled={!isEditable(field.guid)}
                  style={{
                    backgroundColor: isEditable(field.guid)
                      ? "white"
                      : "#E9E7E7",
                    width: "100%",
                  }}
                  size="small"
                  value={field.value}
                  onChange={(e) => {
                    handleFieldChange(field, e.target.value);
                  }}
                  autoComplete="off"
                />

                <IconButton
                  onClick={() => {
                    if (!isEditable(field.guid)) {
                      addForEdition(field.guid, field.value);
                    } else {
                      cancelEdition(field.guid);
                    }
                  }}
                >
                  {isEditable(field.guid) ? (
                    <DoNotDisturb
                      style={{ color: "red", width: "16px", height: "16px" }}
                    />
                  ) : (
                    <Edit
                      style={{
                        color: "#10366E",
                        width: "16px",
                        height: "16px",
                      }}
                    />
                  )}
                </IconButton>

                <div
                  style={{
                    display: isEditable(field.guid) ? "inline-block" : "none",
                  }}
                >
                  <IconButton
                    onClick={() => {
                      setPreviousValue("");
                      removeFromEdition(field.guid);
                    }}
                  >
                    <Save
                      style={{ color: "green", width: "16px", height: "16px" }}
                    />
                  </IconButton>
                </div>
              </div>
              <div className="my-2 w-full">
                <Divider />
              </div>
            </div>
          ))}
        </List>
      ) : (
        <Alert severity="info" className="w-full">
          <label className="text-xs">{localize.error_no_fields}</label>
        </Alert>
      )}
    </div>
  );
}
